<ng-template #menu>
    <div cdkMenu class="cm-menu">
        @for (a of $actions(); track a.id) {
            <div cdkMenuItem class="cm-action" [class.cm-destructive]="a.variant === 'destructive'" (cdkMenuItemTriggered)="action.emit(a.id)">
                @if (a.icon) {
                    <i class="cm-icon far" [class]="a.icon"></i>
                }
                {{ a.label }}
            </div>
        }
    </div>
</ng-template>
